import React, { Component, createRef } from 'react';
import PropTypes from 'prop-types';
import { Title, Heading_2 as Heading2 } from '@huggg/react-components';

import Dialog from './Dialog';
import styles from './info-dialog.module.scss';
import dictionary from 'config/dictionary.json';

class InfoDialog extends Component {
  constructor() {
    super();
    this.modalRef = createRef();

    this.open = this.open.bind(this);
    this.close = this.close.bind(this);
    this.onConfirmClick = this.onConfirmClick.bind(this);
  }

  open() {
    this.modalRef.current && this.modalRef.current.open();
  }

  close() {
    this.modalRef.current && this.modalRef.current.close();
  }

  onConfirmClick(event) {
    const { onConfirm } = this.props;

    event && event.preventDefault();
    onConfirm && onConfirm();
  }

  render() {
    const { header, body, confirmButtonText, onConfirm, ...rest } = this.props;

    return (
      <Dialog ref={this.modalRef} contentClassName={styles.content} {...rest}>
        {header && <Title className={styles.header}>{header}</Title>}
        {body && <Heading2 className={styles.body}>{body}</Heading2>}
      </Dialog>
    );
  }
}

InfoDialog.defaultProps = {
  confirmButtonText: dictionary.confirmationDialog.defaultConfirmButton,
};

InfoDialog.propTypes = {
  confirmButtonText: PropTypes.string.isRequired,
  body: PropTypes.node,
  header: PropTypes.node,
  onConfirm: PropTypes.func,
};

export default InfoDialog;
